import type { IVoyageCrew } from './voyageCrew'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageUiBuyStuff } from './voyageUiBuyStuff-sidecar'
import { voyageUiSubsystem } from './voyageUiSubsystem-sidecar'

export function onEnter(obj: IVoyageCrew) {
  // swapItemHere(obj, true)

  if (voyagePicker.get().selectedCrew === obj) {
    // voyageUiBuyStuff.setOpen(true)
  }
}

export function onLeave(obj: IVoyageCrew) {
  voyageUiSubsystem.setOpen(false)
  voyageUiBuyStuff.setOpen(false)
}

export function onSelectedCrewOn(obj: IVoyageCrew) {
  if (voyageUiBuyStuff.get().isOpen) {
    voyageUiSubsystem.setOpen(false)
  } else {
    voyageUiSubsystem.setOpen(true, obj.tile)
  }
}
